export const GET_VIDEOGAMES = "GET_VIDEOGAMES";
export const GET_GENRES = "GET_GENRES";
export const FILTER_BY_GENRES = "FILTER_BY_GENRES";
export const FILTER_CREATED = "FILTER_CREATED";
export const ORDER_BY_NAME = "ORDER_BY_NAME";
export const ORDER_BY_RATING = "ORDER_BY_RATING";
export const GET_BY_NAME = "GET_BY_NAME";
export const POST_VIDEOGAME = "POST_VIDEOGAME";
export const GET_PLATFORMS = "GET_PLATFORMS";
export const GET_DETAIL = "GET_DETAIL";
export const CLEAR_DETAILS = "CLEAR_DETAILS";
export const CLEAR_VIDEOGAMES = "CLEAR_VIDEOGAMES";
export const DELETE_VIDEOGAME ="DELETE_VIDEOGAME";
export const CLEAR_VIDEOGAME_CACHE = "CLEAR_VIDEOGAME_CACHE";
export const CLEANER ="CLEANER"
export const CLEAN_GAME = "CLEAN_GAME"
export const CLEANER_NAME = "CLEANER_NAME"